export const InteractiveAuthenticationRequiredMessage: string =
  "INTERACTIVE_AUTHENTICATION_REQUIRED";
